import { useContext } from 'react';
import { AuthContext } from 'context/authContext';
import { useMutation, useQueryClient } from 'react-query';
import apiEndPoints from 'services/apiEndPoints';
import makeApiRequest from 'services/makeApiRequest';
import { ErrorToast } from 'services/toasterService';
import useUpdateTaskData from './useUpdateTaskData';

export default function useDeleteAttachement(id) {
  const queryClient = useQueryClient();
  const updateTaskDataMutation = useUpdateTaskData();
  const { authState } = useContext(AuthContext);

  return useMutation(
    async (data) => {
      const response = await makeApiRequest.delete(
        apiEndPoints.TASK_ATTACHMENTS,
        {
          data: data,
        }
      );
      return response?.data;
    },
    {
      onSuccess: (data) => {
        queryClient.invalidateQueries('get-all-buckets');
        updateTaskDataMutation.mutate({
          updated_by_id: authState?.user_id,
          id: id,
        });
      },
      onError: (error) => {
        ErrorToast({ text: error.response.data.message });
      },
    }
  );
}
